import { useEffect, useState } from "react";
import "../../css/FormularioActor.css";
import { NMTipoDocumento } from "../../shared/Denominaciones";
import axios from "axios";
import { HEADERS_API } from "../NuevaGuia";
import { ValidarNum, ValidarNumLtr } from "../../shared/Regex";

export default function FormularioTransportista({funcionAgregar, funcionCancelar}){

    //#region HOOKS STATE
    //==========================================================================================
    const[tipoDoc, setTipoDoc] = useState("6");
    const[nroDoc, setNroDoc] = useState("");
    const[razSoc, setRazSoc] = useState("");
    const[registroMTC, setRegistroMTC] = useState("");

    // Estados de contenido
    const[indicadorBusqueda, setIndicadorBusqueda] = useState(<></>);

    // Estados de validación
    const[datosCompletos, setDatosCompletos] = useState(true);

    //#endregion

    //#region HOOKS EFFECT
    //==========================================================================================

    useEffect(()=>{

        if(tipoDoc == '6' && nroDoc.length == 11){
            ConsultaRucSunat();
        }
    },[nroDoc]);

    useEffect(()=>{
        try{
            if(tipoDoc == "" || nroDoc.length != 11 || razSoc == ""){
                throw new Error();
            }
            HandlerDatosCompletos(false);
        }catch(error){
            HandlerDatosCompletos(true);
        }
    },[tipoDoc, nroDoc, razSoc])

    //#endregion

    //#region HANDLERS
    //==========================================================================================
    const HandlerTipoDoc = (codigo) => setTipoDoc(codigo);
    const HandlerNroDoc = (valor) => {
        if(ValidarNum(valor) || valor == ""){
            setNroDoc(valor);
        }
    }
    const HandlerRegistroMTC = (valor) => {
        if(ValidarNumLtr(valor) || valor == ""){
            setRegistroMTC(valor.toUpperCase());
        }
    }
    const HandlerRazSoc = (valor) => setRazSoc(valor.toUpperCase());
    const HandlerIndicadorBusqueda = (valor) => setIndicadorBusqueda(valor);
    const HandlerDatosCompletos = (valor) => setDatosCompletos(valor);
    //#endregion

    //#region FUNCIONES
    //==========================================================================================

    // FUNCIONES ASÍNCRONAS
    async function ConsultaRucSunat(){
        try{
            HandlerIndicadorBusqueda(
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            );
            let response = await axios.get(URL_CONSULTA_RUC_SUNAT,{
                headers:HEADERS_API,
                params:{
                    ruc: nroDoc
                }
            }).catch(error => {
                throw new Error(error.message);
            });

            HandlerRazSoc(response.data.nombre);
            HandlerIndicadorBusqueda(<></>);
        }catch(error){
            console.log(error.message);
            HandlerIndicadorBusqueda(<></>);
        } 
    }

    const registrarTransportista = async () =>{
        try{
            let response = await axios.post(URL_INSERTAR_TRANSPORTISTA,{
                codigoUsuario: "",
                ruc: nroDoc,
                razSoc: razSoc,
                registroMTC: registroMTC
            },{
                headers:HEADERS_API
            }).catch(error=>{
                throw new Error(error.message);
            });

            console.log(response.data);
        }catch(error){
            console.log(error);
        }
    }

    // Ejecutar función recibida como parámetro
    const ejecutarFuncion = async () => {
        funcionAgregar(tipoDoc, nroDoc, razSoc, registroMTC);
        await registrarTransportista();
        funcionCancelar();
    }
    //#endregion

    //#region CONTENIDO
    //==========================================================================================
    return(<>
    <div id="modal-actor" className="d-flex justify-content-center align-items-center">
        <div id="formulario-registro">
            <div className="bg-primary text-white p-2 fs-4">
                NUEVO TRANSPORTISTA
            </div>
            <div className="p-2">
                <div className="row">
                    <div className="pb-3 col-12 d-flex">
                        <label htmlFor="f-trans-nro-doc" className="col-form-label text-nowrap px-3 fw-semibold col-2">RUC:</label>
                        <input onChange={e => HandlerNroDoc(e.target.value)} value={nroDoc} maxLength={11} id="f-trans-nro-doc" type="text" className="form-control mx-2" placeholder="N° Documento" autoComplete="off" />
                        <div>
                            {indicadorBusqueda}
                        </div>
                    </div>
                    <div className="pb-3 col-12 d-flex">
                        <label htmlFor="f-trans-raz-soc" className="col-form-label text-nowrap px-3 fw-semibold col-2">Razón social:</label>
                        <input type="text" disabled value={razSoc} className="form-control mx-2" />
                    </div>
                    <div className="pb-3 col-12 d-flex">
                        <label htmlFor="f-trans-registro-mtc" className="col-form-label px-3 fw-semibold col-2">Registro MTC (opcional):</label>
                        <input onChange={e => HandlerRegistroMTC(e.target.value)} value={registroMTC} maxLength={20} id="f-trans-registro-mtc" type="text" className="form-control mx-2" />
                    </div>
                    <div className="p-2 d-flex justify-content-around">
                        <button onClick={funcionCancelar} className="btn btn-secondary">Cancelar</button>
                        <button onClick={ejecutarFuncion} disabled={datosCompletos} className="btn btn-primary">Aceptar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>);
    //#endregion
}

//#region CONSTANTES
//==========================================================================================
const URL_CONSULTA_RUC_SUNAT = process.env.REACT_APP_URL_CONSULTA_RUC_SUNAT;
const URL_INSERTAR_TRANSPORTISTA = process.env.REACT_APP_URL_INSERTAR_TRANSPORTISTA;
//#endregion
